var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-0"},[_c('div',{attrs:{"id":"mykadSpace"}})])}
var staticRenderFns = []

export { render, staticRenderFns }